export default [
  {
    name: 'CustomersFormSettings',
    path: 'settings/customers-form-settings',
    component: () => import('pages/settings/customers-form-settings/CustomersFormSettings.vue')
  }
]
